import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_sounds, update_sounds } from '../../../Controller/actions';
import { NewContext } from '../../../Context/NewContext';

import './soundsform.css';

export const SoundsForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
    const [sounds, setSounds] = useState({
        name: state ? state.name : "",
        isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
        // isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    const [imgObj, setImgObj] = useState({ previewSound: state ? state.preview : "", mp3file: state ? state.mp3file : "" });

    const handleChange = (e) => {
        // if (e.target.name === 'soundsCategory' || e.target.name === "soundsTag") {
        //     let soundsCategoryAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
        //     setSounds({ ...sounds, [e.target.name]: soundsCategoryAry });
        // } else {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
        setSounds({ ...sounds, [e.target.name]: e.target.value });
        // }
    };

    const handleFileInput = (e) => {
        if (e.target.files[0].size > 5242880) {
            toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
        } else {
            setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
            setSounds({ ...sounds, [e.target.name]: e.target.files[0] });
        }
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: sounds[e.target.name] ? false : true });
        setSounds({ ...sounds, [e.target.name]: sounds[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateSounds;
        setIsLoading(true);
        if (state) {
            createUpdateSounds = await update_sounds(updatedData, state._id);
        } else {
            // console.log("==========sounds==========", sounds);
            createUpdateSounds = await add_sounds(sounds)
        }
        setIsLoading(false);
        if (createUpdateSounds) {
            const { message, status } = createUpdateSounds;
            if (status) {
                toast.success(message);
                navigate("/sounds");
                setSounds({
                    name: "",
                    isPremium: false,
                    // isActive: false,
                });
                setImgObj({ previewSound: "", mp3file: "" });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];
        // Object.keys(sounds).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (sounds[fieldName].toString().length > 0) {
        //             // if (fieldName === "soundsZip") {
        //             //     if (sounds.soundsZip.type.split('/')[1] !== 'x-zip-compressed') {
        //             //         allFieldDone.push(false);
        //             //         toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is must be a zip file!!`);
        //             //     } else {
        //             //         allFieldDone.push(true);
        //             //     }
        //             // } else {
        //             allFieldDone.push(true);
        //             // }
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });
        // if (!state) {
        //     Object.keys(imgObj).map(async (fieldName, i) => {
        //         if (!imgObj[fieldName]) {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //             return allFieldDone;
        //         } else {
        //             allFieldDone.push(true);
        //         }
        //     });
        // }

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateSounds;
        //     setIsLoading(true);
        //     if (state) {
        //         createUpdateSounds = await update_sounds(sounds, state._id);
        //     } else {
        //         // console.log("==========sounds==========", sounds);
        //         createUpdateSounds = await add_sounds(sounds)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateSounds) {
        //         const { message, status } = createUpdateSounds;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/sounds");
        //             setSounds({
        //                 id: "",
        //                 name: "",
        //                 isPremium: false,
        //                 // isActive: false,
        //             });
        //             setImgObj({ previewSound: "", mp3file: "" });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Sounds` : `Add Sounds`}</h3>
            </div>
            <Row>
                <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>Preview : </h6>
                            <img className='w-100' src={`${imgObj.previewSound ? imgObj.previewSound : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : sounds.name} />
                        </Col>
                    </Row>
                </Col>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='sounds_name' column md={3} sm={4}>Name</Form.Label>
                                <Col><Form.Control id='sounds_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : sounds.name} required /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='sounds_previewSound' column md={3} sm={4}>Preview</Form.Label>
                                <Col><Form.Control id='sounds_previewSound' type="file" accept='image/*' name='previewSound' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='sounds_mp3file' column md={3} sm={4}>Mp3File</Form.Label>
                                <Col><Form.Control id='sounds_mp3file' type="file" name='mp3file' accept='audio/mp3' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='sounds_isPremium' column md={3} sm={4}>Premium</Form.Label>
                                <Col><Form.Check type="switch" id="sounds_isPremium" name='isPremium' onChange={handleSwitch} checked={updatedData.isPremium ? updatedData.isPremium : sounds.isPremium} role="button" /></Col>
                            </Col>
                            {/* <Col lg={12} className="mb-3">
                                <Row className='align-items-center'>
                                    <Form.Label htmlFor='sounds_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="sounds_isActive" name='isActive' onChange={handleSwitch} checked={sounds.isActive} role="button" /></Col>
                                </Row>
                            </Col> */}
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                <Col lg={3} md={3} sm={4}></Col>
                                <Col>
                                    <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                        {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                    </Button>
                                    {/* <Link to=""> */}
                                    <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    {/* </Link> */}
                                </Col>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

SoundsForm.defaultProps = {
    title: "Sounds Form"
};

export default SoundsForm;